import { useState, useEffect, useRef } from 'react';
import { ToggleButton, ToggleButtonGroup, SpeedDial } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import './vstLogs.css';

export default function VstLogs() {
  const id = useRef(Math.random());
  const [displayedContent, setDisplayedContent] = useState('');
  const [stringLength, setStringLength] = useState(0);
  const [receivedData, setReceivedData] = useState('');
  const terminalRef = useRef();
  const [logCollectionStarted, setLogCollectionStarted] = useState(false);
  const [ws, setWs] = useState(null);
  const intervalRef = useRef();

  useEffect(() => {
    const newString = receivedData;
    if (newString.length < stringLength) {
      setDisplayedContent((prevContent) => prevContent + newString);
    } else {
      const newContent = newString.slice(stringLength);
      setDisplayedContent((prevContent) => prevContent + newContent);
    }
    setStringLength(newString.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receivedData]);

  const handleConnect = () => {
    id.current = Math.random();
    const newWs = new WebSocket(
      `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/vms/ws?connectionId=${id.current}`
    );
    newWs.onopen = () => {
      newWs.send(
        JSON.stringify({
          api_key: 'get_logs',
        })
      );
    };
    newWs.onmessage = (event) => {
      const json = JSON.parse(event.data);
      // console.log("json: ", json)
      if (json.logs) {
        setReceivedData(json.logs);
      }
    };
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      newWs.send(
        JSON.stringify({
          api_key: 'get_logs',
        })
      );
    }, 500);
    setWs(newWs);
  };

  const handleDisconnect = () => {
    clearInterval(intervalRef.current);
    if (ws) {
      ws.close();
    }
    setWs(null);
  };

  const handleLogCollectionToggle = (event, newLogCollectionStarted) => {
    setLogCollectionStarted(newLogCollectionStarted);
    if (newLogCollectionStarted) {
      handleConnect();
    } else {
      handleDisconnect();
    }
  };

  const scrollToBottom = () => {
    terminalRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <ToggleButtonGroup value={logCollectionStarted} exclusive onChange={handleLogCollectionToggle}>
        <ToggleButton value>Start Log Collection</ToggleButton>
        <ToggleButton value={false}>Stop Log Collection</ToggleButton>
      </ToggleButtonGroup>
      <div className="terminal" style={{ whiteSpace: 'pre-line', maxHeight: '76vh', overflow: 'scroll' }}>
        {displayedContent != null && <p>{displayedContent}</p>}
        <div ref={terminalRef} />
      </div>
      <SpeedDial
        ariaLabel="SpeedDial openIcon example"
        sx={{ position: 'fixed', bottom: 2, right: 2 }}
        onClick={scrollToBottom}
        icon={<ArrowDownwardIcon />}
      />
    </>
  );
}
